document.addEventListener('DOMContentLoaded', () => {
  // Selección del formulario y elementos clave específicos
  const pillFilterForm = document.getElementById('FacetFiltersPillsForm');
  if (!pillFilterForm) return; // Salir si el formulario no existe

  const removeFilterButtons = pillFilterForm.querySelectorAll('.active-facets__button');
  const removeAllButton = pillFilterForm.querySelector('.active-facets__button-remove');

  // Aplicar lógica solo a los elementos relacionados con este formulario
  // Manejo de clic en botones de quitar filtro
  removeFilterButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault(); // Previene el comportamiento por defecto
      const url = button.getAttribute('href'); // URL específica del botón
      window.location.href = url; // Redirige a la URL para quitar el filtro
    });
  });

  // Manejo del botón "Eliminar todo"
  if (removeAllButton) {
    removeAllButton.addEventListener('click', (event) => {
      event.preventDefault(); // Previene el comportamiento por defecto
      const url = removeAllButton.getAttribute('href'); // URL base para eliminar filtros
      window.location.href = url; // Redirige a la URL sin filtros
    });
  }
});